import { render, staticRenderFns } from "./UnpaidInvoice.vue?vue&type=template&id=8fbaa4a6&scoped=true&"
import script from "./UnpaidInvoice.vue?vue&type=script&lang=js&"
export * from "./UnpaidInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fbaa4a6",
  null
  
)

export default component.exports